import React from 'react'
import './CSS/PrivacyPolicy.css'

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy">

      <div className="privacy-policy-container">

        <h1>Privacy Policy</h1>

        <p className="privacy-policy-updated">
          Last Updated: August 2026
        </p>

        <p>
          Welcome to BadtameezDil GameStore. We respect your privacy and are
          committed to protecting the information you provide while using our
          website. This Privacy Policy explains what information we collect,
          how we use it, and how you can contact us regarding your information.
        </p>

        <h2>1. Information We Collect</h2>

        <p>
          When you use BadtameezDil GameStore, we may collect information that
          you provide when creating or accessing an account. This may include
          your name and email address.
        </p>

        <p>
          If you choose to sign in using Google, certain account information,
          such as your name and email address, may be provided to us through
          Google's authentication service.
        </p>

        <p>
          We may also store information necessary to provide features of the
          website, such as your shopping cart and information you voluntarily
          provide when contacting us.
        </p>

        <h2>2. How We Use Your Information</h2>

        <p>
          We use the information we collect to:
        </p>

        <ul>
          <li>Provide and maintain your account.</li>
          <li>Provide the features and services available through our website.</li>
          <li>Maintain your shopping cart and related account functionality.</li>
          <li>Respond to customer questions and support requests.</li>
          <li>Maintain, improve, and protect the website.</li>
        </ul>

        <h2>3. Google Sign-In</h2>

        <p>
          BadtameezDil GameStore allows customers to sign in using their Google
          account. When you choose this option, Google handles the
          authentication process and may provide us with basic account
          information necessary to create and maintain your account.
        </p>

        <p>
          We do not receive your Google account password through our website.
        </p>

        <h2>4. Account and Shopping Cart Data</h2>

        <p>
          When you create an account, information associated with your account
          may be stored so that we can provide account-related functionality.
        </p>

        <p>
          Your shopping cart information may also be stored so that the items
          you add to your cart can be associated with your account and
          maintained while you use the website.
        </p>

        <h2>5. Cookies and Local Storage</h2>

        <p>
          Our website may use browser storage and similar technologies to
          maintain authentication information and provide certain website
          functionality.
        </p>

        <p>
          These technologies help the website remember your login state and
          provide a smoother experience when you return to the website.
        </p>

        <h2>6. Data Security</h2>

        <p>
          We take reasonable measures to protect the information associated
          with your account and our website. However, no method of storing or
          transmitting information over the internet can be guaranteed to be
          completely secure.
        </p>

        <h2>7. Your Privacy Rights</h2>

        <p>
          If you have questions about the personal information associated with
          your account, or if you would like to request information about,
          correction of, or deletion of your personal information, you can
          contact us using the email address provided below.
        </p>

        <p>
          Requests may be subject to applicable legal and operational
          requirements.
        </p>

        <h2>8. Contact Us</h2>

        <p>
          If you have any questions about this Privacy Policy or your
          information, please contact us at:
        </p>

        <p className="privacy-policy-email">
          badtameezdilgamestore@gmail.com
        </p>

        <h2>9. Changes to This Privacy Policy</h2>

        <p>
          We may update this Privacy Policy from time to time as our website,
          services, or practices change. Any updated version will be posted on
          this page with a revised "Last Updated" date.
        </p>

      </div>

    </div>
  )
}

export default PrivacyPolicy

